export function hasTransferFiles(dataTransfer: DataTransfer | null): boolean {
  if (!dataTransfer) {
    return false;
  }
  if (dataTransfer.files && dataTransfer.files.length > 0) {
    return true;
  }
  if (Array.from(dataTransfer.types || []).includes("Files")) {
    return true;
  }
  return Array.from(dataTransfer.items || []).some(
    (item) => item.kind === "file",
  );
}
